import React from "react";
import { cn } from "../../lib/utils";
import { Button } from "../ui/button";

const actionStyles = {
  default: "border-[#242E42] text-[#9CA3AF] hover:text-[#F3F4F6]",
  primary: "bg-[#E2B05E] text-[#0B0E14] hover:bg-[#F0C47A]",
  view: "border-[#242E42] text-[#9CA3AF] hover:text-[#3AB8D6]",
  edit: "border-[#242E42] text-[#9CA3AF] hover:text-[#E2B05E]",
  delete: "text-red-400 hover:text-red-300 hover:bg-red-500/10",
  approve: "bg-emerald-500 text-white hover:bg-emerald-600",
  reject: "border-red-500 text-red-500 hover:bg-red-50",
  info: "border-[#3AB8D6]/50 text-[#3AB8D6] hover:bg-[#3AB8D6]/10",
  warning: "border-[#E2B05E]/50 text-[#E2B05E] hover:bg-[#E2B05E]/10",
};

const buttonVariantByTone = {
  primary: "default",
  approve: "default",
  reject: "outline",
  view: "outline",
  edit: "outline",
  info: "outline",
  warning: "outline",
  default: "outline",
};

export function ActionButton({
  icon: Icon,
  label,
  mobileLabel,
  tone = "default",
  iconOnly = false,
  size = "sm",
  className,
  children,
  ...props
}) {
  const content = children || label;
  const compactLabel = mobileLabel || label;

  return (
    <Button
      size={iconOnly ? "icon" : size}
      variant={buttonVariantByTone[tone] || "outline"}
      className={cn(
        "shrink-0",
        actionStyles[tone] || actionStyles.default,
        iconOnly ? "h-8 w-8 p-0" : "min-h-8",
        className,
      )}
      {...props}
    >
      {Icon ? <Icon className={cn("h-4 w-4", !iconOnly && "sm:mr-1")} /> : null}
      {iconOnly ? null : (
        <>
          {compactLabel && label && compactLabel !== label ? (
            <>
              <span className="sm:hidden">{compactLabel}</span>
              <span className="hidden sm:inline">{label}</span>
            </>
          ) : (
            <span>{content}</span>
          )}
        </>
      )}
    </Button>
  );
}

export function ActionGroup({ children, className, align = "end" }) {
  const alignClass = align === "start" ? "justify-start" : "justify-end";

  return (
    <div className={cn("flex flex-wrap items-center gap-2", alignClass, className)}>
      {children}
    </div>
  );
}

export default ActionButton;
